<template>
  <div>
    <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Create Gmail Account</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
            <v-row justify="center" dense>
                 <v-col cols="12" sm="3">
                    <p><b>Enter Email</b></p>
                    <v-text-field  outlined dense type="text" v-model="email" ></v-text-field>
                </v-col>
            </v-row>
             <v-row justify="center" dense>
                <v-btn color="primary" dark class="mb-2" :loading="loader" @click="save()">Create</v-btn>
               </v-row>
               </v-card>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      email:"",
      loader:false
       }),
  methods: {
      save(){
         if(this.email == "" || this.email==null){
        this.showSnackbar("red", "Please Enter Email");
        return
       }
        const formData = {
            email: this.email
        }
       this.loader=true
       axios
    .post("/Admission/createGmailAccount",formData)
    .then((res) => {
        if (res.data.flag == "Yes") {
            this.loader=false
            this.showSnackbar("green", res.data.snackbar); 
        } 
        else if (res.data.flag == "No") {
        this.showSnackbar("#b71c1c", res.data.snackbar);   
        this.loader=false
        }
    })
    .catch((error) => {
        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
    })
    .finally(() => {
        // 'use strict';
        this.loader=false
    });
      },

      onLoad(){

      },
      showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
};
</script>
<style scoped>
.table-head-background {
  background-color: #fcc96f;
  color: #fff;
  font-weight: 700;
}
.tc-title {
  background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
  color: #fff;
  font-weight: 700;
  margin: 0px !important;
  padding: 0px !important;
}
.text-left {
  font-size: 14px;
  font-weight: bold;
}
.text {
  color: blue;
  font-weight: 600;
  font-size: 14px;
}
</style>
